export const ACTIVE_INGREDIENT_CREATE_REQUESTED =
    'ACTIVE_INGREDIENT_CREATE_REQUESTED';
export const ACTIVE_INGREDIENT_CREATE_SUCCEEDED =
    'ACTIVE_INGREDIENT_CREATE_SUCCEEDED';
export const ACTIVE_INGREDIENT_CREATE_FAILED =
    'ACTIVE_INGREDIENT_CREATE_FAILED';

export const ACTIVE_INGREDIENT_UPDATE_REQUESTED =
    'ACTIVE_INGREDIENT_UPDATE_REQUESTED';
export const ACTIVE_INGREDIENT_UPDATE_SUCCEEDED =
    'ACTIVE_INGREDIENT_UPDATE_SUCCEEDED';
export const ACTIVE_INGREDIENT_UPDATE_FAILED =
    'ACTIVE_INGREDIENT_UPDATE_FAILED';

export const ACTIVE_INGREDIENT_DELETE_REQUESTED =
    'ACTIVE_INGREDIENT_DELETE_REQUESTED';
export const ACTIVE_INGREDIENT_DELETE_SUCCEEDED =
    'ACTIVE_INGREDIENT_DELETE_SUCCEEDED';
export const ACTIVE_INGREDIENT_DELETE_FAILED =
    'ACTIVE_INGREDIENT_DELETE_FAILED';

export const ACTIVE_INGREDIENTS_SET = 'ACTIVE_INGREDIENTS_SET';
export const ACTIVE_INGREDIENT_SET = 'ACTIVE_INGREDIENT_SET';
